/**
 * Maps exact server `mvm:battle-ended` `message` strings (offline / busy-auto resolve)
 * to i18n keys under `worldMap.mvmNotifications.*` — avoids showing raw backend copy.
 */
/** Loose translator type — avoids i18next `TFunction` overload issues with strict generics. */
export type MvmI18nTranslate = (key: string, options?: Record<string, unknown>) => string
const SERVER_AUTO_RESOLVE_MSG_TO_I18N_KEY: Record<string, string> = {
  'MvM auto-result (defender was offline): your attack was repelled — no hex battle. Characters earned loss XP.':
    'worldMap.mvmNotifications.offlineAttackerRepelled',
  'MvM auto-result (defender was offline): your side held the castle — no hex battle. Characters earned XP.':
    'worldMap.mvmNotifications.offlineDefenseHeld',
  'MvM auto-result (defender was offline): your alliance took the castle — no hex battle. The defender was an alliance leader: their treasury was reduced by 90%; that amount was shared among attackers. XP was granted.':
    'worldMap.mvmNotifications.offlineAttackerWonLeaderPenalty',
  'MvM auto-result (defender was offline): your castle fell — as alliance leader, 90% of your resources were lost. You cannot join the winning alliance. No hex battle.':
    'worldMap.mvmNotifications.offlineDefenderLeaderFall',
  'MvM auto-result (defender was offline): defense lost — no hex battle. Your characters earned loss XP.':
    'worldMap.mvmNotifications.offlineDefenseLostAlly',
  'MvM auto-result (defender was offline): your alliance took the castle — no hex battle. XP and plunder applied.':
    'worldMap.mvmNotifications.offlineAttackerWonPlunder',
  'MvM auto-result (defender was offline): your castle fell — resources plundered. No hex battle.':
    'worldMap.mvmNotifications.offlineCastleFallPlunder',
  'MvM resolved automatically (defender offline).': 'worldMap.mvmNotifications.offlineResolvedGeneric',

  'MvM auto-defense (castle owner was busy attacking elsewhere): your attack was repelled — no hex battle.':
    'worldMap.mvmNotifications.busyAutoAttackerRepelled',
  'MvM auto-defense: your castle held while you were attacking elsewhere — no hex battle.':
    'worldMap.mvmNotifications.busyAutoDefenseHeld',
  'MvM auto-defense: victory — defender was an alliance leader; treasury was reduced by 90% and that loot was shared among attackers. No hex battle.':
    'worldMap.mvmNotifications.busyAutoAttackerWonLeader',
  'MvM auto-defense: your castle fell — as alliance leader, treasury penalty applied. No incorporation choice.':
    'worldMap.mvmNotifications.busyAutoDefenderLeaderFall',
  'MvM auto-defense: defense lost — no hex battle.': 'worldMap.mvmNotifications.busyAutoDefenseLost',
  'MvM auto-defense: your side took the castle — 30% plunder from the owner. No hex battle.':
    'worldMap.mvmNotifications.busyAutoAttackerWonPlunder',
  'MvM auto-defense: your castle fell while you were attacking elsewhere — 30% plundered. No alliance incorporation step.':
    'worldMap.mvmNotifications.busyAutoCastleFallAway',
  'MvM castle auto-defense resolved without hex combat.': 'worldMap.mvmNotifications.busyAutoResolvedGeneric',

  'Tower captured!': 'worldMap.mvmNotifications.towerCaptured',
  'Tower defended!': 'worldMap.mvmNotifications.towerDefended',
  'Tower attack failed.': 'worldMap.mvmNotifications.towerAttackFailed',
  'Tower lost!': 'worldMap.mvmNotifications.towerLost',
  'Tower captured — defenders did not contest in time.':
    'worldMap.mvmNotifications.towerCapturedNoShow',
  'Tower captured — defenders arrived too late.':
    'worldMap.mvmNotifications.towerCapturedLate',
  'Tower lost — you did not send champions before the attacker arrived.':
    'worldMap.mvmNotifications.towerLostNoShow',
  'Tower lost — your champions did not reach the tower before the attacker.':
    'worldMap.mvmNotifications.towerLostLate',
}

/** User-facing toast for `mvm:battle-ended` when `autoResolvedWithoutHex` is true. */
export function mvmAutoResolveBattleToast(rawMessage: string | undefined | null, t: MvmI18nTranslate): string {
  const s = (rawMessage ?? '').trim()
  if (!s) return ''
  const key = SERVER_AUTO_RESOLVE_MSG_TO_I18N_KEY[s]
  if (key) return t(key)
  return t('worldMap.mvmNotifications.autoResolveUnknownOutcome')
}
